"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.RadioInput = exports.BaseRadioInputProps = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for text
 */
const RadioInput = ({
  name,
  id,
  label,
  setFocus,
  disabled,
  checked,
  value,
  error,
  errorMsg,
  onChange,
  onClick,
  ...props
}) => {
  // ref the input field
  const radioInput = (0, _react.useRef)(null);
  // set focus to the field programatically if the prop is true
  (0, _react.useEffect)(() => {
    if (setFocus) radioInput.current.focus();
  }, []);
  const cssComponentClass = 'ccl__form-input';
  const cssTextClass = 'ccl__text';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: [cssComponentClass, `${cssComponentClass}--is-radio-input`, disabled ? `${cssComponentClass}--is-disabled` : ''].join(' '),
    ...props,
    children: [error && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        type: "error",
        size: "sm"
      }), errorMsg]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl__field-control ccl__field-control--input-selectors",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
        className: `ccl__field-control__label ccl__field-control__label--is-radio ${cssTextClass} ${cssTextClass}--body-text`,
        htmlFor: id,
        disabled: disabled,
        children: [label, /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: "ccl__field-control__label__input",
          ref: radioInput,
          name: name,
          id: id,
          type: "radio",
          disabled: disabled,
          checked: checked,
          value: value,
          onChange: onChange,
          onClick: onClick
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl__field-control__indicator"
        })]
      })
    })]
  });
};
exports.RadioInput = RadioInput;
const BaseRadioInputProps = exports.BaseRadioInputProps = {
  /**
   * What id to use on the radio input. Sometimes this is the same value as name but it must be unique.
   */
  id: _propTypes.default.string.isRequired,
  /**
   * What value to give the field fo submission
   */
  value: _propTypes.default.string.isRequired,
  /**
   * What field label to use
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /**
   * Is the field disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Set focus to field
   */
  setFocus: _propTypes.default.bool,
  /**
   * Preset the radio value to checked
   */
  checked: _propTypes.default.bool
};
RadioInput.defaultProps = {
  disabled: false,
  setFocus: false,
  checked: false,
  error: false,
  errorMsg: ''
};